;(function (global, $) {
    'use strict';
    
    function initTabStrip(selector) {        
        var tabStrip = $(selector).kendoTabStrip({
            tabPosition: 'left',
            animation: false
        }).data('kendoTabStrip');
    }

    $(document).ready(function () {
        var sliderTimeoutInSeconds = 8;
        
        $('#slider-body').bizSlider('#slider-controls',  sliderTimeoutInSeconds * 1000);
        $('#slider2-body').bizSlider('#slider2-controls', sliderTimeoutInSeconds * 1000);

        initTabStrip('#business-services-tabstrip');
        $('#business-services-panelbar').kendoPanelBar({ expandMode: 'single' });
    });

    $('#getstarted-select-button').click(function (event) {
        window.location.href = $('#getstarted-business-types').find(':selected').val();
    });

    $('#getstarted-business-types').on('change', function (ev) {
        var productUrl = $(ev.currentTarget).val();

        if (productUrl) {
            global.location.href = productUrl;
        }
    });

}(window, jQuery));
